<template>
  <div>
    <div class="panel-title">
      {{resultsLength}} results found for "<b>{{searchMessage}}</b>"
    </div>
    <table class="table table-striped bank-accounts table-fundings">
      <thead>
        <tr>
          <th>First name</th>
          <th>Last name</th>
          <th v-if="showCompanyNames">Company name 1</th>
          <th v-if="showCompanyNames">Company name 2</th>
          <th v-if="!showCompanyNames">Account name</th>
          <th>Email</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="investor in investors">
          <tr v-for="(account, index) in investor.accounts" :key="`${index}-account-${account.accountId}`">
            <td>{{investor.firstName}}</td>
            <td>{{investor.lastName}}</td>
            <td v-if="showCompanyNames">{{account.organizationName || '---'}}</td>
            <td v-if="showCompanyNames">{{account.alternateCompanyName || '---'}}</td>
            <td v-if="!showCompanyNames">{{account.accountName}}</td>
            <td>{{investor.email}}</td>
            <td>
              <button type="button" class="btn btn-details btn-outline" v-on:click="goToViewDetail(investor.id, investor.userType, investor.firstName)">View details</button>
            </td>
          </tr>
          <tr v-if="!investor.accounts || investor.accounts.length === 0" :key="investor.id">
            <td>{{investor.firstName}}</td>
            <td>{{investor.lastName}}</td>
            <td v-if="showCompanyNames">---</td>
            <td v-if="showCompanyNames">---</td>
            <td v-if="!showCompanyNames">---</td>
            <td>{{investor.email}}</td>
            <td>
              <button type="button" class="btn btn-details btn-outline" v-on:click="goToViewDetail(investor.id, investor.userType, investor.firstName)">View details</button>
            </td>
          </tr>
        </template>
        <template v-for="account in accounts">
          <tr v-for="(user, index) in account.users" :key="`${index}-user-${user.userId}`">
            <td>{{user.firstName}}</td>
            <td>{{user.lastName}}</td>
            <td v-if="showCompanyNames">{{account.organizationName || '---'}}</td>
            <td v-if="showCompanyNames">{{account.alternateCompanyName || '---'}}</td>
            <td v-if="!showCompanyNames">{{account.accountName}}</td>
            <td>{{user.email}}</td>
          <td>
            <button type="button" class="btn btn-details btn-outline" v-on:click="goToViewDetail(user.id, user.userType, user.firstName)">View details</button>
          </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { UserTypes } from '@/data/static/userTypes';

export default {
  name: 'SearchByNameOrEmailResults',
  data() {
    return {};
  },
  props: {
    results: {
      type: Object,
      required: true,
      default: {},
    },
    searchMessage: {
      type: String,
      required: true,
      default: '',
    },
    showCompanyNames: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    investors() {
      return this.results.users || [];
    },
    accounts() {
      return this.results.accounts || [];
    },
    resultsLength() {
      let totalAccountsFromUsers = 0;
      let totalUsersFromAccounts = 0;
      this.investors.forEach((investor) => {
        // Count each account or count 1 if no accounts
        totalAccountsFromUsers += Math.max((investor.accounts || []).length, 1);
      });
      this.accounts.forEach((account) => {
        totalUsersFromAccounts += account.users.length;
      });
      return totalAccountsFromUsers + totalUsersFromAccounts;
    },
  },
  methods: {
    ...mapActions('user', [
      'storeUserInSessionStorage',
    ]),
    goToViewDetail(userId, type, name) {
      this.storeUserInSessionStorage(userId);

      let routeParams;
      if (type === UserTypes.FINANCIAL_ADVISOR.name) {
        routeParams = { name: 'EditFinancialAdvisor', params: { name, userId } };
      } else {
        routeParams = { name: 'UserDetail', params: { name, userId } };
      }
      this.$router.push(routeParams);
    },
  },
};
</script>



// WEBPACK FOOTER //
// SearchByNameOrEmailResults.vue?56ac2146